import { CardsGroupStatus } from '../../constants/constants';
import { getDaysDiffBetweenDates } from '../utils';

export function getUsersPosition (user, usersInCharge) {
    let positions = []
    for (const userInCharge of Object.values(usersInCharge)) {
        if (userInCharge.attributes.position === null) continue
        if (!positions.includes(userInCharge.attributes.position)) {
            positions.push(userInCharge.attributes.position)
        }
    }
    if (user.attributes && user.attributes.position) {
        if (!positions.includes(user.attributes.position)) {
            positions.push(user.attributes.position)
        }
    }
    return positions
}

function getPositionsInCardsGroup(cardsGroupData) {
    let positions = []
    for (const card of Object.values(cardsGroupData.cards)) {
        if (card.user.attributes.position) {
            if (!positions.includes(card.user.attributes.position)) {
                positions.push(card.user.attributes.position)
            }
        }
        for (const userInCharge of Object.values(card.users_in_charge)) {
            if (!userInCharge.attributes.position) continue
            if (!positions.includes(userInCharge.attributes.position)) {
                positions.push(userInCharge.attributes.position)
            }
        }
    }
    return positions
}

export function addTimePos(cardsGroupsData, projectStartDate) {
    Object.values(cardsGroupsData).forEach(cardsGroup => {
        let lastUpdateTime = cardsGroup.attributes.last_update_datetime
        let finishDate = cardsGroup.attributes.finish_date
        if (finishDate !== 'None') {
            let plannedTimePos = getDaysDiffBetweenDates(projectStartDate, finishDate)
            cardsGroup.attributes.planned_time_pos = plannedTimePos
        }
        let cardsGroupTimePos = getDaysDiffBetweenDates(projectStartDate, lastUpdateTime)
        cardsGroup.attributes.time_pos = cardsGroupTimePos
    })
    return cardsGroupsData
}

export function addPositions(cardsGroupsData) {
    Object.values(cardsGroupsData).forEach(cardsGroup => {
        cardsGroup.positions = getPositionsInCardsGroup(cardsGroup)
    })
    return cardsGroupsData
}